namespace RioERP.Users {
    export interface CustomerSMSRequest extends Serenity.ServiceRequest {
        status?: string;
        ids?: string;
    }
}
